export default __webpack_public_path__ + "static/media/Welcome1.2a86858f.jpg";